import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

const words = [
  "Slow Roasted",
  "Single Origin",
  "Ethically Sourced",
  "Hand Poured",
  "Cast Iron & Ember",
  "Cup by Cup",
];

export const EditorialMarquee = () => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1.4, ease: [0.19, 1, 0.22, 1] }}
      viewport={{ once: true, amount: 0.4 }}
      data-testid="editorial-marquee"
      className="relative bg-ink border-y border-bone/10 py-8 md:py-10 overflow-hidden"
    >
      <Marquee gradient={false} speed={28} pauseOnHover>
        {[...Array(3)].map((_, r) =>
          words.map((w, i) => (
            <span
              key={`${r}-${i}`}
              className="flex items-center gap-10 md:gap-16 px-6 md:px-10 font-serif italic text-bone text-[9vw] md:text-[7vw] leading-none tracking-tightest"
            >
              {w}
              <span className="text-gold text-[6vw] md:text-[4vw] not-italic font-sans">✦</span>
            </span>
          ))
        )}
      </Marquee>
    </motion.section>
  );
};
